<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :width="width"
    :append-to-body="true"
    :destroy-on-close="destroyOnClose"
    @close="handleClose"
    class="custom-dialog"
  >
    <!-- 自定义标题栏 -->
    <template #title>
      <div class="custom-title">
        <icon-title
          :icon-color="'var(--text-color)'"
          :title="title"
          icon="icon-shuxian"
        />
      </div>
    </template>
    <!-- 自定义内容插槽 -->
    <slot name="content"></slot>
    <!-- 底部按钮 -->
    <template #footer>
      <div class="dialog-footer" v-if="showFooter">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "CustomDialog",
  props: {
    // 是否显示底部按钮
    showFooter: {
      type: Boolean,
      default: true,
    },
    // 控制弹窗显示/隐藏
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 弹窗标题（如“新增被考核对象”）
    title: {
      type: String,
      default: "编辑信息",
    },
    // 弹窗宽度
    width: {
      type: [String, Number],
      default: "50%",
    },
    // 标签宽度
    labelWidth: {
      type: String,
      default: "100px",
    },
    // 关闭时是否销毁表单（避免缓存）
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
      // this.resetForm(); // 重置表单
    },
    // 取消按钮
    handleCancel() {
      this.handleClose();
      this.$emit("cancel");
    },
    // 确定按钮（表单验证+提交）
    handleConfirm() {
      // 验证通过，将表单数据传递给父组件
      this.$emit("confirm");
    //   this.handleClose(); // 提交后关闭弹窗
    },
  },
};
</script>

<style scoped lang="scss">
/* 覆盖element原有样式 */
::v-deep.el-dialog__wrapper {
  .el-dialog {
    border-radius: 20px;
  }
}
.custom-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px 30px;
    max-height: 70vh;
    overflow-y: auto;
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
